import { Fragment, useState } from 'react';

import { InvoiceService } from '../../hoa-don/InvoiceService';

import { ConfirmDialogService } from '../../../AppConfirmDialog';

import { useToolbar } from '../../../shared/hooks/Toolbar';
import { useDataTable } from '../../../shared/hooks/DataTable';

import { DialogView } from '../../hoa-don/component/DialogView';
import { DialogCancel } from '../../hoa-don/component/DialogCancel';
import { DialogSelectInvoice } from '../../hoa-don/component/DialogSelectInvoice';

import { DialogStatement } from '../components/DialogStatement';
import { DialogAttachment } from '../components/DialogAttachment';

export const List = () => {

  const header = 'Hoá đơn huỷ';
  const dataKey = 'invoiceId';

  const [displaySelectInvoice, setDisplaySelectInvoice] = useState(null);
  const [selectedInvoices, setSelectedInvoices] = useState(null);
  const [displayCancel, setDisplayCancel] = useState(false);

  const [displayStatement, setDisplayStatement] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [displayView, setDisplayView] = useState(false);

  const [displayUpload, setDisplayUpload] = useState(false);
  const [documentType, setDocumentType] = useState(InvoiceService.documentType_Cancel);
  const { render: renderDataTable, reloadLazyData, selectedItems } = useDataTable({
    header,
    dataKey,
    columns: [
      { field: 'invoiceSerial', header: 'Ký hiệu', width: 100, matchMode: 'contains' },
      { field: 'invoiceNumber', header: 'Số hoá đơn', width: 110, matchMode: 'contains' },
      { field: 'invoiceDate', header: 'Ngày hoá đơn', width: 120, dataType: 'date' },
      {
        field: 'sendTaxStatus', header: 'Trạng thái gửi CQT', width: 180, matchMode: 'contains', filterType: 'dropdown', filterOptions: InvoiceService.sendTaxStatuses, dataType: 'custom', customCell(rowData: any): any {
          if ([3, 4, 5].includes(rowData.sendTaxStatus)) {
            return <span className={`underline send-tax-status send-tax-status-${rowData.sendTaxStatus}`}>{InvoiceService.sendTaxStatuses.find(item => item.value === rowData.sendTaxStatus)?.label}</span>;
          }
          return <span className={`send-tax-status send-tax-status-${rowData.sendTaxStatus}`}>{InvoiceService.sendTaxStatuses.find(item => item.value === rowData.sendTaxStatus)?.label}</span>;
        }
      },
      {
        field: 'buyerLegalName', header: 'Khách hàng', minWidth: 200, matchMode: 'contains', dataType: 'custom', customCell(rowData: any): any {
          return rowData.buyerLegalName || rowData.buyerDisplayName;
        }
      },
      { field: 'documentNoView', header: 'Số thông báo', width: 120, matchMode: 'contains' },
      {
        field: '', header: 'Biên bản', width: 110, sortable: false, dataType: 'custom', customCell(rowData): any {
          const text = rowData.hasDocument ? 'Đã lập biên bản' : 'Lập biên bản';
          return (
            <span className="underline text-primary" onClick={() => setDisplayStatement(true)}>{text}</span>
          );
        }, style: { justifyContent: 'center' }
      },
      { field: 'invoiceNote', header: 'Lý do huỷ', width: 110, matchMode: 'contains' },
      {
        field: '', header: 'Thao tác', width: 100, sortable: false, dataType: 'custom', customCell(rowData: any): any {
          return (
            <div className='flex gap-3'>
              <i className="pi pi-link " title="File dính kèm" onClick={() => setDisplayUpload(true)}></i>
              <i className="pi pi-eye " title="Xem hoá đơn" onClick={() => viewInvoice(rowData)}></i>
            </div>
          );
        }, style: { justifyContent: 'center' }
      }
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      params.IsOtherInvoice = false;
      return InvoiceService.getListCancels(params);
    },
    selectionMode: 'single'
  });

  const viewInvoice = (rowData) => {
    setSelectedInvoice({
      id: rowData.invoiceId,
      buyerTaxCode: rowData.buyerTaxCode,
      invoiceSerial: rowData.invoiceSerial,
      invoiceNumber: rowData.invoiceNumber
    });
    setDisplayView(true);
  }

  const { renderToolbar } = useToolbar({
    dataKey,
    reloadLazyData,
    // otherActions: [
    //   {
    //     label: 'Huỷ hoá đơn', icon: 'pi pi-fw pi-times', className: 'iam-toolbar', command: () => {
    //       setDisplaySelectInvoice(true);
    //     }
    //   }
    // ]
  });

  const onAddSelectedItems = (items) => {
    if (items && items.length) {
      let _DisplayCancel = true;

      for (const iv of items) {
        if (![0, 4].includes(iv.invoiceStatus) || ![4].includes(iv.sendTaxStatus)) {
          console.log(iv.invoiceSerial, iv.invoiceNumber);
          _DisplayCancel = false;
          ConfirmDialogService.showInvalid('Bạn chỉ được Hủy hóa đơn ký gửi thành công ở trạng thái Gốc - Giải trình');
          break;
        }
      }

      if (_DisplayCancel) {
        setSelectedInvoices(items);
        setDisplayCancel(true);
      }
    }
  }

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}

      <DialogSelectInvoice display={displaySelectInvoice} setDisplay={setDisplaySelectInvoice} addSelectedItems={onAddSelectedItems} selectionMode="checkbox"
        invoiceStatus="0,4" sendTaxStatus="4" />
      <DialogCancel display={displayCancel} setDisplay={setDisplayCancel} selectedItems={selectedInvoices} />

      <DialogAttachment display={displayUpload} setDisplay={setDisplayUpload} selectedItem={selectedItems} />

      <DialogStatement display={displayStatement} setDisplay={setDisplayStatement} selectedItem={selectedItems} documentType={documentType} reloadLazyData={reloadLazyData} title="huỷ" />

      <DialogView display={displayView} setDisplay={setDisplayView} selectedItem={selectedInvoice} />
    </Fragment>
  )
}
